export const isDevelopment = (): boolean => {
  try {
    return (
      typeof process !== 'undefined' &&
      process.env &&
      process.env.NODE_ENV === 'development'
    );
  } catch {
    return typeof window !== 'undefined' && window.location.hostname === 'localhost';
  }
};

